import { ContainerConfig, ControlConfig } from "./model";

/**
 * @author chen yu
 * @date 12/01/2021 17:01:31
 * @class
 */
class LayoutMan {

    /**
     * @author chen yu
     * @date 12/01/2021 17:01:56
     * @memberof LayoutMan
     */
    constructor() {

        /**
         * @type {LayoutConfig}
         */
        this.LayoutConfig = null;

        /**
         * @type {Array.<BaseConfig>}
         */
        this.SelectedList = [];

        /**
         * @type {object}
         */
        this.LayoutContext = null;

        /**
         * @type {boolean}
         */
        this.IsAllowDrag = true;

        /**
         * @type {Map}
         */
        this.Context = new Map();
    }

    AllowDrag() {
        this.IsAllowDrag = true;
    }

    DisallowDrag() {
        this.IsAllowDrag = false;
    }

    /**
     * @author chen yu
     * @date 12/01/2021 17:01:07
     * @param {LayoutConfig} layoutConfig
     * @memberof LayoutMan
     * @description 设置布局配置
     */
    SetLayoutConfig(layoutConfig) {
        this.LayoutConfig = layoutConfig;
    }

    /**
     * @author chen yu
     * @date 12/01/2021 17:01:31
     * @returns {Array.<BaseConfig>} 
     * @memberof LayoutMan
     * @description 获取选中列表
     */
    GetSelectedList() {
        return this.SelectedList;
    }

    /**
     * @author chen yu
     * @date 12/01/2021 17:01:04
     * @param {*} [selectList=[]]
     * @memberof LayoutMan
     * @description 设置选中列表
     */
    SetSelectedList(selectList = []) {

        if (!Array.isArray(selectList)) {
            selectList = [selectList];
        }
        
        this.SelectedList = selectList
    }

    /**
     * @author chen yu
     * @date 09/02/2021 01:02:49
     * @memberof LayoutMan
     * @description 获取控件列表
     */
    GetControlConfigList() {

        if (!this.LayoutConfig) {
            return [];
        }

        let _list = [];

        let _tempList = [this.LayoutConfig];
        for (let _i = 0; _i < _tempList.length; _i++) {

            const _item = _tempList[_i];

            if (_item instanceof ControlConfig) {
                _list.push(_item);
            } else if (_item instanceof ContainerConfig) {
                _tempList = _tempList.concat(_item.Children);
            }

        }

        return _list;

    }

}

export default LayoutMan;